

import * as React from 'react';

import { NoWrapParagraph } from '../../../components/cirium/NoWrapParagraph';
import { CiriumModal } from '../../../components/cirium/CiriumModal';
import {
  Box,
  Button,
  CheckCircleIcon,
  Flex,
  Heading5,
} from '@flightstats/airframe-react';

export type ChangePasswordSuccessModalProps = {
  showModal: boolean,
  confirmSuccess: () => void,
  title: string,
};

export const ChangePasswordSuccessModal: React.FC<ChangePasswordSuccessModalProps> = ({
  showModal,
  confirmSuccess,
  title,
}) => (
  <CiriumModal showModal={showModal} title={title}>
    <Flex flexDirection="column" alignItems="center">
      <CheckCircleIcon height="100px" />
      <Box my="25px">
        <Heading5 textAlign="center">
          Password updated
        </Heading5>
        <NoWrapParagraph textAlign="center" fontSize="14px">
          Click OK to login with the new password.
        </NoWrapParagraph>
      </Box>
      <Button my="25px" onClick={confirmSuccess}>
        OK
      </Button>
    </Flex>
  </CiriumModal>
);
